import HeroSection from './HeroSection';
import InternshipCardsSection from './InternshipCardsSection';
import TimelineSection from './TimelineSection';
import ProjectHighlightsSection from './ProjectHighlightsSection';
import SkillsAcquiredSection from './SkillsAcquiredSection';
import CertificatesSection from './CertificatesSection';
import ResearchSection from './ResearchSection';

const Experience = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--color-body-bg)' }}>
      <HeroSection />
      <InternshipCardsSection />
      <TimelineSection />
      <ProjectHighlightsSection />
      <SkillsAcquiredSection />
      <CertificatesSection />
      <ResearchSection />
    </div>
  );
};

export default Experience;
